import React from 'react'

export default ({bloc: {background_color, title, url}}) => (
  <div className="block block--video">
    <div className="block__meta">
      <h3 className="block__title">{title}</h3>
    </div>

    <div className="block__video">
      <div className="video-container" dangerouslySetInnerHTML={{__html: url}} />
      <div className="block__mask" style={{backgroundColor: background_color}} />
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Block/BlockVideo/BlockVideo.js